<template>
    <v-container grid-list-md fluid>
        <v-window v-model="globalStep">
            <v-window-item :value="0">
                <!-- // ** first title line -->
                <v-row class="d-flex mb-1">
                    <v-col cols="auto" class="d-flex align-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>

                    <v-col class="align-center justify-start">
                        <v-row no-gutters>
                            <v-col cols="12" >
                                <h2 class="d-flex align-center justify-start flex-wrap">
                                    Rapprochement Chiffre d'affaires / T.V.A. déclarée
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-icon
                                                color="secondary"
                                                v-bind="props"
                                                class="ml-2"
                                                icon="$oss-help"
                                            >
                                            </v-icon>
                                        </template>

                                        <h3>
                                            Si les écarts sont nuls, le rapprochement est validé
                                            automatiquement.
                                        </h3>
                                        <br />
                                        <hr />
                                        <h4>
                                            Ce contrôle construit les tableaux repartis par taux, se
                                            basant sur les lignes pas lettrés, en fin d'exercices
                                            N-1 et N, des comptes 411 416 418 419 487.
                                        </h4>
                                        <h3>
                                            Il est indispensable que les lettrages soyent terminés,
                                            sinon des documents seront ajoutés au calcul et les
                                            écarts faussés.
                                        </h3>
                                    </v-tooltip>
                                </h2>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex align-center justify-start flex-wrap">
                                {{ `Statut : ${checkStatus}` }}
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="5" class="d-flex flex-grow-0 flex-shrink-0 justify-end align-center">
                        
                            <!-- ** upload -->
                            <v-tooltip location="bottom" text="Lier un document">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        @click="dialogAuditCheckDocumentsManager = true"
                                        v-bind="props"
                                        size="x-small"
                                        icon="$oss-upload"
                                        class="mx-1"
                                    />
                                </template>
                            </v-tooltip>

                            <!-- ** chat -->
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        @click="openChat = !openChat"
                                        v-bind="props"
                                        size="x-small"
                                        icon="$oss-chat"
                                        class="mx-1"
                                    >
                                    </v-btn>
                                </template>
                                <span>Message</span>
                            </v-tooltip>

                            <v-btn
                                v-if="accountingPeriod && accountingPeriod.closed"
                                disabled
                                size="small"
                                class="mx-1"
                            >
                                Enregistrer
                            </v-btn>

                            <v-btn
                                v-else
                                @click.stop="validateAuditCheckResult()"
                                size="small"
                                class="mx-1"
                            >
                                Enregistrer
                            </v-btn>

                            <v-btn
                                :disabled="
                                    loading ||
                                    dataLoading ||
                                    !accountingPeriod ||
                                    !accountingPeriod ||
                                    (accountingPeriod && accountingPeriod.closed)
                                "
                                @click.stop="validated = !validated; validateAuditCheckResult()"
                                size="small"
                                class="mx-1"
                            >
                                {{ validated ? "Invalider" : "Valider" }}
                            </v-btn>

                            <template v-if="isEnableReview">
                                <div
                                    style="
                                        border-right: 2px solid black;
                                        width: 2px;
                                        height: 25px;
                                        margin: 0 4px;
                                    "
                                />

                                <v-icon
                                    :disabled="
                                        reviewed === 1 ||
                                        !isEnableReview ||
                                        !validated ||
                                        loading ||
                                        dataLoading
                                    "
                                    size="small"
                                    icon="$fa-thumbs-up"
                                    color="primary"
                                    class="mx-1"
                                    @click="
                                        reviewed = 1;
                                        validateAuditCheckResult('REVIEW');
                                    "
                                    >$fa-thumbs-up</v-icon
                                >
                                <v-icon
                                    :disabled="
                                        reviewed === -1 ||
                                        !isEnableReview ||
                                        !validated ||
                                        loading ||
                                        dataLoading
                                    "
                                    size="small"
                                    icon="$fa-thumbs-down"
                                    color="primary"
                                    class="mx-1"
                                    @click="
                                        reviewed = -1;
                                        validateAuditCheckResult('REVIEW');
                                    "
                                />
                                <div
                                    style="
                                        border-right: 2px solid black;
                                        width: 1px;
                                        height: 25px;
                                        margin: 0 4px;
                                    "
                                />
                            </template>

                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-prev
                                        v-bind="props"
                                        :disabled="!previousControl"
                                        @click="
                                            reviewed = 0;
                                            openChat = false;
                                            goToPreviousControl();
                                        "
                                    />
                                </template>
                                <div style="width: 400px" class="d-flex justify-center">
                                    Contrôle précédent :
                                    {{
                                        previousControl && previousControl.title
                                            ? previousControl.title
                                            : ""
                                    }}
                                </div>
                            </v-tooltip>

                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <v-btn-next
                                        v-bind="props"
                                        @click="
                                            reviewed = 0;
                                            openChat = false;
                                            goToNextControl();
                                        "
                                        :disabled="!nextControl"
                                    />
                                </template>
                                <div style="width: 400px" class="d-flex justify-center">
                                    Contrôle suivant :
                                    {{ nextControl && nextControl.title ? nextControl.title : "" }}
                                </div>
                            </v-tooltip>

                            <div
                                style="
                                    border-right: 2px solid black;
                                    width: 1px;
                                    height: 25px;
                                    margin: 0 4px;
                                "
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$dots_vertical"
                                        v-bind="props"
                                        class="mx-1"
                                        color="secondary"
                                    />
                                </template>
                                <v-list nav>
                                    <v-list-item
                                        :disabled="!auditCheckResult || !auditCheckResult.id"
                                        @click="deleteAuditCheckResult(auditCheckResult.id)"
                                    >
                                        <v-list-item-title>
                                            Supprimer les commentaires et les validations du
                                            contrôle
                                        </v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small"> $oss-trash </v-icon>
                                        </template>
                                    </v-list-item>

                                    <v-list-item @click="displayActivityDialog = true">
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                    </v-col>
                </v-row>

                <v-card v-if="loading || dataLoading" elevation="0">
                    <v-card-text style="text-align: center" class="pa-0">
                        <v-progress-circular
                            :size="70"
                            :width="7"
                            color="primary"
                            indeterminate
                            style="margin: 24px"
                        />
                    </v-card-text>
                </v-card>

                <template v-else>
                    <!-- // ** Régime d'imposition + Enregistrer -->
                    <template v-if="company">
                        <v-card-subtitle class="py-2 mb-0">
                            <v-row no-gutters>
                                <v-col cols="auto" class="d-flex align-center pr-8">
                                    <h3 v-if="!company.incomeCategory" class="text-red">
                                        {{ $t("settings.incomeCategory") }} : à renseigner dans 'Mon
                                        dossier'
                                    </h3>
    
                                    <h3 v-else>
                                        {{ $t("settings.incomeCategory") }} :
                                        {{ $t("settings." + company.incomeCategory) }}
                                    </h3>
                                </v-col>
    
                                <v-col cols="auto" class="d-flex align-center pr-8">
                                    <h3 v-if="!company.taxRegime" class="text-red">
                                        {{ $t("settings.taxRegime") }} : à renseigner dans 'Mon dossier'
                                    </h3>
    
                                    <h3 v-else>
                                        {{ $t("settings.taxRegime") }} :
                                        {{ $t("settings." + company.taxRegime) }}
                                    </h3>
                                </v-col>
    
                                <v-col cols="auto" class="d-flex align-center pr-8">
                                    <h3 v-if="!company.vatOption" class="text-red">
                                        {{ $t("settings.vatOption") }} : à renseigner dans 'Mon dossier'
                                    </h3>
    
                                    <h3 v-else>
                                        {{ $t("settings.vatOption") }} :
                                        {{ $t("settings." + company.vatOption) }}
                                    </h3>
                                </v-col>
    
                                <v-col cols="auto" class="d-flex align-center">
                                    <h3 v-if="!company.vatSystem" class="text-red">
                                        {{ $t("settings.vatSystem") }} : à renseigner dans 'Mon dossier'
                                    </h3>
    
                                    <h3 v-else>
                                        {{ $t("settings.vatSystem") }} :
                                        {{ $t("settings." + company.vatSystem) }}
                                    </h3>
                                </v-col>
    
                                <!-- <v-col cols="auto" class="d-flex py-2 px-6"> -->
                                <!-- <v-toolbar dense> -->
                                <!-- <v-select
                                        v-model="selectedOptionnalsColumns"
                                        :items="selectGapsResumeTableHeaders"
                                        return-object
                                        chips
                                        outlined
                                        class="oss-"
                                        hide-details
                                        dense
    
                                        :menu-props="{ maxHeight: '400' }"
                                        label="Ajouter des colonnes"
                                        multiple
    
                                    ></v-select> -->
                                <!-- hint="Pick your favorite states"
                                    @change="changedSelectedOptionnalColumns()"
                                    :item-title="text"
                                    persistent-hint -->
                                <!-- </v-col> -->
    
                                <v-spacer />
    
                                <v-col
                                    cols="auto"
                                    class="d-flex text-right align-center"
                                    v-if="!hideControl"
                                >
                                </v-col>
    
                                <!-- // ** icon more_vert(ical) with upsert + deleteACR -->
                                <v-col
                                    cols="auto"
                                    class="d-flex text-center align-center"
                                    style="border-left: 1px #ededed solid"
                                >
                                    <!-- // // start -->
                                    <v-menu offset-y> </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-subtitle>
                    </template>
    
                    <template
                        v-if="
                            gapsResumeTable &&
                            gapsResumeTable[0] &&
                            gapsResumeTable[0].errors &&
                            gapsResumeTable[0].errors.someNotLetteredPayement &&
                            gapsResumeTable[0].errors.someNotLetteredPayement.length
                        "
                    >
                        <v-alert border="start" border-color="red" class="py-4 my-4 text-red">
                            <h3 class="text-start">
                                Les clients suivants comportent des écritures sans comptes de produits qui pourraient correspondre à des paiements non lettrés et qui faussent le tableau.
                            </h3>
    
                            <h4 class="text-start">
                                Veuillez terminer les lettrages afin que les colonnes soient correctement renseignées:
                            </h4>
    
                            <template
                                v-for="(notLettered, index) in gapsResumeTable[0].errors
                                    .someNotLetteredPayement"
                                key="index"
                            >
                                <h4>- {{ notLettered }}</h4>
                            </template>
                        </v-alert>
                    </template>
    
                    <template
                        v-if="
                            gapsResumeTable &&
                            gapsResumeTable[1] &&
                            gapsResumeTable[1].errors &&
                            gapsResumeTable[1].errors.declarationsWith4458x &&
                            gapsResumeTable[1].errors.declarationsWith4458x.length
                        "
                    >
                        <v-alert border="start" border-color="red" class="py-4 my-4 text-red">
                            <h3 class="text-start">
                                Le contrôle ne peut pas répartir par taux des lignes comptables passées
                                dans les comptes génériques commençant par c/4458.
                            </h3>
                            <h4 class="text-start">
                                Veuillez corriger les déclarations suivantes en utilisant des comptes de
                                type "445720" ou "445660":
                            </h4>
                            <template
                                v-for="decl in gapsResumeTable[1].errors.declarationsWith4458x"
                                key="decl.id"
                            >
                                <h4>- {{ formatDate(decl.date) }}</h4>
                            </template>
                        </v-alert>
                    </template>
    
                    <!-- // ** if show471GL -->
                    <v-card
                        v-if="show471GL && !hideControl"
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 my-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <v-row>
                                        <v-col cols="auto">
                                            <h5 class="pl-4">
                                                Ecritures en attente d'affectation dans les comptes 471
                                            </h5>
                                        </v-col>
    
                                        <v-col cols="auto" class="d-flex align-center">
                                            <v-icon
                                                color="secondary"
                                                @click="snackbar2 = true"
                                                icon="$oss-help"
                                                size="x-small"
                                            />
    
                                            <v-snackbar
                                                v-model="snackbar2"
                                                multi-line
                                                :timeout="-1"
                                                width="70vw"
                                            >
                                                <h3 class="py-1">
                                                    Si le type est "Banque", veuillez affecter les
                                                    opérations bancaires en attente.
                                                </h3>
                                                <h3 class="py-1">
                                                    Autrement, si le solde est nul, tout va bien ! Vous
                                                    pouvez accéder au contrôle.
                                                </h3>
    
                                                <template #actions>
                                                    <v-btn-icon
                                                        icon="$oss-close"
                                                        size="small"
                                                        @click.stop="snackbar2 = false"
                                                        class="white"
                                                        color="white"
                                                    />
                                                </template>
                                            </v-snackbar>
                                        </v-col>
    
                                        <v-spacer />
                                    </v-row>
                                </v-card-title>
                            </v-col>
    
                            <!-- // ** expand icon -->
                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6" />
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                isItemExpanded('expand471')
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            @click="
                                                addRemoveItemExpanded(
                                                    true,
                                                    'expand471',
                                                    'refreshGeneralLedger471',
                                                )
                                            "
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
    
                        <!-- // ++ item0.tables (sales) || item0.table (VAT) -->
                        <v-card-subtitle
                            v-if="show471GL && isItemExpanded('expand471')"
                            class="pa-0 mb-0"
                            :key="refreshGeneralLedger471"
                        >
                            <GeneralLedger
                                :companyId="companyId"
                                :accountingPeriodId="accountingPeriodId"
                                :accountableAccountFilter="['471']"
                                :inNm1="false"
                                :hideOptions="true"
                                :withoutLetteringIfHidedOptions="true"
                                :hideBodyAppend="true"
                                :refreshCount="refreshGeneralLedger471"
                            />
                            <!-- :notReconciliated="true" -->
                            <!-- :hideMiscellaneousOperationsBtn="true"
                                :hideThirdPartySwitch="true"
                                :inThirdParty="false" -->
                        </v-card-subtitle>
                    </v-card>
    
                    <!-- // * no selected period -->
                    <template v-if="!accountingPeriod">
                        <v-card-subtitle class="py-2 mb-6">
                            <h4>Aucune période sélectionnée</h4>
                        </v-card-subtitle>
                    </template>
    
                    <!-- // * company not subjected to VAT -->
                    <template v-else-if="isNotSubjectToVAT(company.vatSystem)">
                        <v-card-subtitle class="py-2 mb-6">
                            <h4>Entreprise non soumise à la TVA</h4>
                        </v-card-subtitle>
                    </template>
    
                    <!-- // * closed period -->
                    <template v-else-if="accountingPeriod && accountingPeriod.closed">
                        <v-card-subtitle class="py-2 mb-6">
                            <h4 class="yellow_custom--text">Période Clôturée</h4>
                        </v-card-subtitle>
                    </template>
    
                    <!-- // ** if !hideControl -->
                    <template v-if="!hideControl">
                        <!-- // ++ gapsResumeTable -->
                        <oss-data-table
                            :headers="gapsResumeTableFilteredHeaders0"
                            :items="gapsResumeTable"
                            :dense="true"
                            :loading="loading"
                            fixed-header
                            max-height="60vh"
                        >
                            <!-- :striped="true" -->
                            <!-- // ++ gapsResumeTable  'Chiffre d'affaires calculé || TVA collectée déclarée'-->
                            <template v-slot:item="{ item: item0 }">
                                <!-- ++ icon + title + sumAmounts -->
                                <tr
                                    @click="
                                        addRemoveItemExpanded(item0.expandable, item0.title, undefined)
                                    "
                                    :style="item0.style"
                                    :class="differenceColorClass(item0, item0.title)"
                                >
                                    <!-- ** isExpanded -->
                                    <td class="text-center" style="width: 50px">
                                        <v-icon v-if="item0.expandable">
                                            {{
                                                isItemExpanded(item0.title)
                                                    ? "$fa-chevron-up"
                                                    : "$fa-chevron-down"
                                            }}
                                        </v-icon>
                                    </td>
    
                                    <!-- ** help text + tooltip -->
                                    <td class="text-left" style="width: 300px">
                                        <strong v-if="item0.title">
                                            {{ item0.title }}
                                        </strong>
                                        <strong v-else>-</strong>
    
                                        <v-tooltip v-if="item0.help" location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-icon
                                                    class="pl-2"
                                                    color="secondary"
                                                    icon="$oss-help"
                                                    v-bind="props"
                                                />
                                            </template>
    
                                            <div v-html="item0.help" />
                                        </v-tooltip>
                                    </td>
    
                                    <!-- ** TTC - don't show TTCsum in item0 -->
                                    <td class="text-right" style="width: 100px">
                                        <!-- <h4 v-if="item0.TTCsum">
                                            {{newCommonFormatCurrency(item0.TTCsum, undefined)}}
                                        </h4>
    
                                        <h4 v-else-if="item0.TTCsum === 0">0 €</h4> -->
                                    </td>
    
                                    <!-- ** HTsum -->
                                    <td class="text-right" style="width: 100px">
                                        <h4 v-if="item0.HTsum">
                                            {{ newCommonFormatCurrency(item0.HTsum, undefined) }}
                                        </h4>
    
                                        <h4 v-else-if="item0.HTsum === 0">0 &#x20ac;</h4>
                                    </td>
    
                                    <!-- ** VATsum -->
                                    <td class="text-right" style="width: 100px">
                                        <h4 v-if="item0.VATsum">
                                            {{ newCommonFormatCurrency(item0.VATsum, undefined) }}
                                        </h4>
    
                                        <h4 v-else-if="item0.VATsum === 0">0 &#x20ac;</h4>
                                    </td>
    
                                    <!-- ** v-for detail columns -->
                                    <td
                                        v-for="(key, index) in columnsToShow"
                                        :key="index"
                                        class="text-right"
                                        style="width: 100px; padding-right: 37px"
                                    >
                                        <h5 v-if="item0[key]">
                                            {{ newCommonFormatCurrency(item0[key], undefined) }}
                                        </h5>
    
                                        <h5 v-else-if="item0[key] === 0">0 &#x20ac;</h5>
                                    </td>
    
                                    <!-- ** item0 empty scrollbar align column -->
                                    <td style="width: 35px" class="px-0" />
                                </tr>
    
                                <!-- // ++ item0.tables (sales) || item0.table (VAT) -->
                                <tr v-if="isItemExpanded(item0.title)" class="px-0">
                                    <td colspan="100" class="px-0">
                                        <!-- // ++ "+ Chiffre d'affaires calculé" item0.tables (sales) -->
                                        <template v-if="item0.tables">
                                            <!-- ** "+ Chiffre d'affaires comptable de l'exercice N" -->
                                            <!-- ** "+ Régularisations de début d'exercice" -->
                                            <!-- ** "- Régularisations de fin d'exercice" -->
                                            <!-- ** "+ Régularisations exceptionnelles de fin d'exercice" -->
                                            <oss-data-table
                                                :headers="gapsResumeTableFilteredHeaders0"
                                                :items="item0.tables"
                                                :dense="true"
                                                :hideDefaultHeader="true"
                                                max-height="60vh"
                                            >
                                                <!-- :striped="true" -->
                                                <template #no-data>Aucune anomalie</template>
    
                                                <template v-slot:item="{ item: item1 }">
                                                    <tr
                                                        @click="
                                                            addRemoveItemExpanded(
                                                                item1.expandable,
                                                                item1.title,
                                                                undefined,
                                                            )
                                                        "
                                                        style="background: #fef8ee"
                                                        :class="differenceColorClass(item1)"
                                                    >
                                                        <td class="text-center" style="width: 50px">
                                                            <v-icon v-if="item1.expandable">
                                                                {{
                                                                    isItemExpanded(item1.title)
                                                                        ? "$fa-chevron-up"
                                                                        : "$fa-chevron-down"
                                                                }}
                                                            </v-icon>
                                                        </td>
    
                                                        <td class="text-left" style="width: 300px">
                                                            <strong v-if="item1.title">{{
                                                                item1.title
                                                            }}</strong>
                                                            <strong v-else>-</strong>
    
                                                            <v-tooltip
                                                                v-if="item1.help"
                                                                location="bottom"
                                                            >
                                                                <template v-slot:activator="{ props }">
                                                                    <v-icon
                                                                        class="pl-2"
                                                                        color="secondary"
                                                                        icon="$oss-help"
                                                                        v-bind="props"
                                                                    />
                                                                </template>
    
                                                                <div v-html="item1.help" />
                                                            </v-tooltip>
                                                        </td>
    
                                                        <td
                                                            class="text-right"
                                                            style="
                                                                border-left: 1px solid #dddddd;
                                                                width: 100px;
                                                            "
                                                        >
                                                            <h5 v-if="item1.TTCsum">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        item1.TTCsum,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </h5>
    
                                                            <h5 v-else>0 &#x20ac;</h5>
                                                        </td>
    
                                                        <td
                                                            class="text-right"
                                                            style="
                                                                border-left: 1px solid #dddddd;
                                                                width: 100px;
                                                            "
                                                        >
                                                            <h5 v-if="item1.HTsum">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        item1.HTsum,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </h5>
    
                                                            <h5 v-else>0 &#x20ac;</h5>
                                                        </td>
    
                                                        <td
                                                            class="text-right"
                                                            style="
                                                                border-right: 1px solid #dddddd;
                                                                width: 100px;
                                                            "
                                                        >
                                                            <h5 v-if="item1.VATsum">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        item1.VATsum,
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </h5>
    
                                                            <h5 v-else>0 &#x20ac;</h5>
                                                        </td>
    
                                                        <td
                                                            v-for="(key, index) in columnsToShow"
                                                            :key="index"
                                                            class="text-right"
                                                            style="width: 100px"
                                                        >
                                                            <!-- :style="keyWidth(key)" -->
                                                            <h5 v-if="item1[key]">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        item1[key],
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </h5>
    
                                                            <h5 v-else>0 &#x20ac;</h5>
                                                        </td>
    
                                                        <!-- ** item1 empty scrollbar align column -->
                                                        <td style="width: 24px" class="px-0" />
                                                    </tr>
    
                                                    <tr v-if="isItemExpanded(item1.title)" class="px-0">
                                                        <td colspan="100" class="px-0">
                                                            <!-- <p v-if="item1.table">item1.table: {{item1.table}}</p> -->
    
                                                            <template v-if="item1.table">
                                                                <!-- ** detailled lines -->
                                                                <!-- ** N ['70'] -->
                                                                <!-- ** N-1 ['411', '416', '418', '419', '487'] -->
                                                                <!-- ** N ['411', '416', '418', '419', '487'] -->
                                                                <!-- ** N ['654', '775'] -->
                                                                <oss-data-table
                                                                    :headers="
                                                                        gapsResumeTableFilteredHeaders0
                                                                    "
                                                                    :items="item1.table"
                                                                    :dense="true"
                                                                    :loading="loading"
                                                                    hideDefaultHeader="true"
                                                                    max-height="60vh"
                                                                >
                                                                    <!-- :striped="true" -->
                                                                    <template
                                                                        v-slot:item="{ item: item2 }"
                                                                    >
                                                                        <tr
                                                                            @click="
                                                                                addRemoveItemExpanded(
                                                                                    item2.expandable,
                                                                                    item2.title,
                                                                                    undefined,
                                                                                )
                                                                            "
                                                                            :class="
                                                                                differenceColorClass(
                                                                                    item2,
                                                                                )
                                                                            "
                                                                        >
                                                                            <!-- ** item2.expandable -->
                                                                            <td
                                                                                class="text-center"
                                                                                style="width: 50px"
                                                                            >
                                                                                <v-icon
                                                                                    v-if="
                                                                                        item2.expandable
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        isItemExpanded(
                                                                                            item2.title,
                                                                                        )
                                                                                            ? "$fa-chevron-up"
                                                                                            : "$fa-chevron-down"
                                                                                    }}
                                                                                </v-icon>
                                                                            </td>
    
                                                                            <!-- ** item2.title ex 411000 - Clients - TOTAL -->
                                                                            <td
                                                                                class="text-left"
                                                                                style="width: 300px"
                                                                                :class="
                                                                                    differenceColorClass(
                                                                                        item2,
                                                                                    )
                                                                                "
                                                                            >
                                                                                <strong
                                                                                    v-if="item2.title"
                                                                                >
                                                                                    {{
                                                                                        item2.title
                                                                                    }}</strong
                                                                                >
                                                                                <strong v-else
                                                                                    >-</strong
                                                                                >
                                                                            </td>
    
                                                                            <!-- ** item2.TTCsum -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <h5 v-if="item2.TTCsum">
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            item2.TTCsum,
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h5>
    
                                                                                <h5 v-else>
                                                                                    0 &#x20ac;
                                                                                </h5>
                                                                            </td>
    
                                                                            <!-- ** item2.HTsum -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <h5 v-if="item2.HTsum">
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            item2.HTsum,
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h5>
    
                                                                                <h5 v-else>
                                                                                    0 &#x20ac;
                                                                                </h5>
                                                                            </td>
    
                                                                            <!-- ** item2.VATsum -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <h5 v-if="item2.VATsum">
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            item2.VATsum,
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h5>
    
                                                                                <h5
                                                                                    v-else
                                                                                    style="width: 100px"
                                                                                >
                                                                                    0 &#x20ac;
                                                                                </h5>
                                                                            </td>
    
                                                                            <!-- <template v-if="checkSums(item2) || onlymanualsColumnsHeaders.length">
                                                                                <td class="text-right" style="width: 100px" v-for="(key, index) in columnsToShow" :key="index" >
                                                                                    <oss-text-field-filled
                                                                                        class="oss-"
                                                                                        outlined
                                                                                        dense
                                                                                        hide-details
                                                                                        type="number"
                                                                                        v-model.number="item2[key]"
                                                                                        style="width: 100px"
                                                                                        @update:model-value="modifyManualAmount(acrAmounts, item2, key, 'corrections', item1.generalLedgerText, gapsResumeTable)"
                                                                                        @click.stop
                                                                                    >
                                                                                    </oss-text-field-filled>
                                                                                </td>
                                                                            </template> -->
    
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                                v-for="(
                                                                                    key, index
                                                                                ) in columnsToShow"
                                                                                :key="index"
                                                                            >
                                                                                <v-tooltip
                                                                                    v-if="
                                                                                        item2.HTtextfield &&
                                                                                        key.startsWith(
                                                                                            'HT',
                                                                                        )
                                                                                    "
                                                                                    location="bottom"
                                                                                >
                                                                                    <template
                                                                                        v-slot:activator="{
                                                                                            props,
                                                                                        }"
                                                                                    >
                                                                                        <oss-text-field-filled
                                                                                            v-bind="
                                                                                                props
                                                                                            "
                                                                                            v-model="
                                                                                                item2[
                                                                                                    key
                                                                                                ]
                                                                                            "
                                                                                            :hide-details="
                                                                                                true
                                                                                            "
                                                                                            single-line
                                                                                            dense
                                                                                            @update:model-value="
                                                                                                modifyManualAmount(
                                                                                                    acrAmounts,
                                                                                                    item2,
                                                                                                    key,
                                                                                                    'corrections',
                                                                                                    item1.generalLedgerText,
                                                                                                    gapsResumeTable,
                                                                                                    item1.title,
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                        </oss-text-field-filled>
                                                                                    </template>
                                                                                    <span
                                                                                        >Même signe que
                                                                                        le total</span
                                                                                    >
                                                                                </v-tooltip>
    
                                                                                <template v-else>
                                                                                    <h5
                                                                                        v-if="
                                                                                            item2[key]
                                                                                        "
                                                                                    >
                                                                                        {{
                                                                                            newCommonFormatCurrency(
                                                                                                item2[
                                                                                                    key
                                                                                                ],
                                                                                                undefined,
                                                                                            )
                                                                                        }}
                                                                                    </h5>
                                                                                    <h5 v-else>
                                                                                        0 &#x20ac;
                                                                                    </h5>
                                                                                </template>
                                                                            </td>
    
                                                                            <!-- ** item2 empty scrollbar align column -->
                                                                            <td
                                                                                style="width: 12px"
                                                                                class="px-0"
                                                                            />
                                                                        </tr>
    
                                                                        <tr
                                                                            v-if="
                                                                                isItemExpanded(
                                                                                    item2.title,
                                                                                )
                                                                            "
                                                                            class="px-0"
                                                                        >
                                                                            <td
                                                                                colspan="100"
                                                                                class="px-0"
                                                                            >
                                                                                <template
                                                                                    v-if="item2.table"
                                                                                >
                                                                                    <oss-data-table
                                                                                        :headers="
                                                                                            gapsResumeTableFilteredHeaders0
                                                                                        "
                                                                                        :items="
                                                                                            item2.table
                                                                                        "
                                                                                        :dense="true"
                                                                                        :loading="
                                                                                            loading
                                                                                        "
                                                                                        hideDefaultHeader="true"
                                                                                        max-height="60vh"
                                                                                    >
                                                                                        <!-- :striped="true" -->
                                                                                        <template
                                                                                            v-slot:item="{
                                                                                                item: item3,
                                                                                            }"
                                                                                        >
                                                                                            <tr
                                                                                                :class="
                                                                                                    differenceColorClass(
                                                                                                        item3,
                                                                                                    )
                                                                                                "
                                                                                            >
                                                                                                <td
                                                                                                    class="text-center"
                                                                                                    style="
                                                                                                        width: 50px;
                                                                                                    "
                                                                                                />
    
                                                                                                <!-- ** item3.title ex 411000 - Clients - sans c/7 : payements à lettrer -->
                                                                                                <td
                                                                                                    class="text-left"
                                                                                                    style="
                                                                                                        width: 300px;
                                                                                                    "
                                                                                                >
                                                                                                    <p
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                        v-if="
                                                                                                            item3.title
                                                                                                        "
                                                                                                    >
                                                                                                        {{
                                                                                                            item3.title
                                                                                                        }}
                                                                                                    </p>
                                                                                                    <p
                                                                                                        v-else
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                    >
                                                                                                        -
                                                                                                    </p>
                                                                                                </td>
    
                                                                                                <!-- ** item3.TTCsum -->
                                                                                                <td
                                                                                                    class="text-right"
                                                                                                    style="
                                                                                                        width: 100px;
                                                                                                    "
                                                                                                    :class="
                                                                                                        differenceColorClass(
                                                                                                            item3,
                                                                                                        )
                                                                                                    "
                                                                                                >
                                                                                                    <p
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        v-if="
                                                                                                            item3.TTCsum
                                                                                                        "
                                                                                                    >
                                                                                                        {{
                                                                                                            newCommonFormatCurrency(
                                                                                                                item3.TTCsum,
                                                                                                                undefined,
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
    
                                                                                                    <p
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                        v-else
                                                                                                    >
                                                                                                        0
                                                                                                        &#x20ac;
                                                                                                    </p>
                                                                                                </td>
    
                                                                                                <!-- ** item3.HTsum -->
                                                                                                <td
                                                                                                    class="text-right"
                                                                                                    style="
                                                                                                        width: 100px;
                                                                                                    "
                                                                                                >
                                                                                                    <p
                                                                                                        v-if="
                                                                                                            item3.HTsum
                                                                                                        "
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                    >
                                                                                                        {{
                                                                                                            newCommonFormatCurrency(
                                                                                                                item3.HTsum,
                                                                                                                undefined,
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
    
                                                                                                    <p
                                                                                                        v-else
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                    >
                                                                                                        0
                                                                                                        &#x20ac;
                                                                                                    </p>
                                                                                                </td>
    
                                                                                                <!-- ** item3.VATsum -->
                                                                                                <td
                                                                                                    class="text-right"
                                                                                                    style="
                                                                                                        width: 100px;
                                                                                                    "
                                                                                                >
                                                                                                    <p
                                                                                                        v-if="
                                                                                                            item3.VATsum
                                                                                                        "
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                    >
                                                                                                        {{
                                                                                                            newCommonFormatCurrency(
                                                                                                                item3.VATsum,
                                                                                                                undefined,
                                                                                                            )
                                                                                                        }}
                                                                                                    </p>
    
                                                                                                    <!-- <p style="pStyle + " v-else style="width: 100px">0 €</p> -->
                                                                                                    <p
                                                                                                        v-else
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                        :class="
                                                                                                            differenceColorClass(
                                                                                                                item3,
                                                                                                            )
                                                                                                        "
                                                                                                    >
                                                                                                        0
                                                                                                        &#x20ac;
                                                                                                    </p>
                                                                                                </td>
    
                                                                                                <!-- <template v-if="checkSums(item2) || onlymanualsColumnsHeaders.length">
                                                                                                <td class="text-right" style="width: 100px" v-for="(key, index) in columnsToShow" :key="index" >
                                                                                                    <oss-text-field-filled
                                                                                                        v-if="checkSums(item2) || onlymanualsColumnsHeaders.length"
                                                                                                        class="oss-"
                                                                                                        outlined
                                                                                                        dense
                                                                                                        hide-details
                                                                                                        type="number"
                                                                                                        v-model.number="item2[key]"
                                                                                                        style="width: 100px"
                                                                                                        @update:model-value="modifyManualAmount(acrAmounts, item2, key, 'corrections', item1.generalLedgerText, gapsResumeTable)"
                                                                                                        @click.stop
                                                                                                    >
                                                                                                    </oss-text-field-filled>
                                                                                                </td>
                                                                                            </template> -->
    
                                                                                                <!-- ** columnsToShow -->
                                                                                                <td
                                                                                                    class="text-right"
                                                                                                    style="
                                                                                                        width: 100px;
                                                                                                    "
                                                                                                    v-for="(
                                                                                                        key,
                                                                                                        index
                                                                                                    ) in columnsToShow"
                                                                                                    :key="
                                                                                                        index
                                                                                                    "
                                                                                                >
                                                                                                    <v-tooltip
                                                                                                        v-if="
                                                                                                            item3.HTtextfield &&
                                                                                                            key.startsWith(
                                                                                                                'HT',
                                                                                                            )
                                                                                                        "
                                                                                                        location="bottom"
                                                                                                    >
                                                                                                        <template
                                                                                                            v-slot:activator="{
                                                                                                                props,
                                                                                                            }"
                                                                                                        >
                                                                                                            <oss-text-field-filled
                                                                                                                v-bind="
                                                                                                                    props
                                                                                                                "
                                                                                                                v-model="
                                                                                                                    item3[
                                                                                                                        key
                                                                                                                    ]
                                                                                                                "
                                                                                                                :hide-details="
                                                                                                                    true
                                                                                                                "
                                                                                                                single-line
                                                                                                                dense
                                                                                                                @update:model-value="
                                                                                                                    modifyManualAmount(
                                                                                                                        acrAmounts,
                                                                                                                        item3,
                                                                                                                        key,
                                                                                                                        'corrections',
                                                                                                                        item1.generalLedgerText,
                                                                                                                        gapsResumeTable,
                                                                                                                        item1.title,
                                                                                                                    )
                                                                                                                "
                                                                                                            >
                                                                                                            </oss-text-field-filled>
                                                                                                        </template>
                                                                                                        <span
                                                                                                            >Même
                                                                                                            signe
                                                                                                            que
                                                                                                            le
                                                                                                            total</span
                                                                                                        >
                                                                                                    </v-tooltip>
    
                                                                                                    <template
                                                                                                        v-else
                                                                                                        :style="
                                                                                                            pStyle
                                                                                                        "
                                                                                                    >
                                                                                                        <h5
                                                                                                            v-if="
                                                                                                                item3[
                                                                                                                    key
                                                                                                                ]
                                                                                                            "
                                                                                                        >
                                                                                                            {{
                                                                                                                newCommonFormatCurrency(
                                                                                                                    item3[
                                                                                                                        key
                                                                                                                    ],
                                                                                                                    undefined,
                                                                                                                )
                                                                                                            }}
                                                                                                        </h5>
                                                                                                        <h5
                                                                                                            v-else
                                                                                                        >
                                                                                                            0
                                                                                                            &#x20ac;
                                                                                                        </h5>
                                                                                                    </template>
                                                                                                </td>
    
                                                                                                <!-- ** item3 empty scrollbar align column (1px item3 last td) -->
                                                                                                <td
                                                                                                    style="
                                                                                                        width: 1px;
                                                                                                    "
                                                                                                    class="px-0"
                                                                                                />
                                                                                            </tr>
                                                                                        </template>
                                                                                    </oss-data-table>
                                                                                </template>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </oss-data-table>
    
                                                                <!-- ** all have accountableAccounts GeneralLedger -->
                                                                <!-- // ** GeneralLedger - accountableAccounts -->
                                                                <v-card
                                                                    style="!important; background: #F4F4F4;"
                                                                    elevation="0"
                                                                >
                                                                    <v-card-text
                                                                        @click="
                                                                            addRemoveItemExpanded(
                                                                                item1.expandable,
                                                                                item1.generalLedgerText,
                                                                                'refreshGeneralLedger_general',
                                                                            )
                                                                        "
                                                                        class="pl-6 d-flex align-center"
                                                                    >
                                                                        <v-icon>
                                                                            {{
                                                                                isItemExpanded(
                                                                                    item1.generalLedgerText,
                                                                                )
                                                                                    ? "$fa-chevron-up"
                                                                                    : "$fa-chevron-down"
                                                                            }}
                                                                        </v-icon>
    
                                                                        <h3 class="pl-8">
                                                                            {{
                                                                                item1.generalLedgerText
                                                                            }}
                                                                        </h3>
                                                                    </v-card-text>
    
                                                                    <v-card-text
                                                                        v-if="
                                                                            isItemExpanded(
                                                                                item1.generalLedgerText,
                                                                            )
                                                                        "
                                                                        transition="expand"
                                                                        class="px-0 pt-0 pb-2"
                                                                    >
                                                                        <v-card
                                                                            style="
                                                                                background-color: white;
                                                                                border-radius: 25px;
                                                                            "
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                :key="
                                                                                    refreshGeneralLedger_general
                                                                                "
                                                                            >
                                                                                <v-col cols="12">
                                                                                    <GeneralLedger
                                                                                        :companyId="
                                                                                            companyId
                                                                                        "
                                                                                        :accountingPeriodId="
                                                                                            item1.periodId
                                                                                        "
                                                                                        :accountableAccountFilter="
                                                                                            item1.accountableAccounts
                                                                                        "
                                                                                        :inNm1="false"
                                                                                        :hideOptions="
                                                                                            true
                                                                                        "
                                                                                        :withoutLetteringIfHidedOptions="
                                                                                            true
                                                                                        "
                                                                                        :refreshCount="
                                                                                            refreshGeneralLedger_general
                                                                                        "
                                                                                    >
                                                                                    </GeneralLedger>
                                                                                    <!-- :notReconciliated="true" -->
                                                                                    <!-- :excludedAccountableAccountFilter="['512000', '589999']" -->
                                                                                    <!-- :hideMiscellaneousOperationsBtn="true" -->
                                                                                    <!-- :hideThirdPartySwitch="true" -->
                                                                                    <!-- :inThirdParty="false" -->
                                                                                </v-col>
                                                                            </v-row>
    
                                                                            <!-- // ** OD -->
                                                                            <v-row no-gutters>
                                                                                <v-col
                                                                                    style="
                                                                                        padding-bottom: 0;
                                                                                    "
                                                                                >
                                                                                    <v-card-title
                                                                                        style="
                                                                                            padding-top: 20px;
                                                                                            padding-bottom: 0;
                                                                                            padding-left: 0;
                                                                                        "
                                                                                    >
                                                                                        <v-spacer />
    
                                                                                        <!-- <v-btn
                                                                                        v-if="(accountingPeriod && accountingPeriod.closed)"
                                                                                        rounded
                                                                                         size="small"
                                                                                        disabled
                                                                                    >
                                                                                        OD
                                                                                    </v-btn> -->
                                                                                        <!-- <v-btn
                                                                                        v-else
                                                                                        rounded
                                                                                         size="small"
                                                                                        dark
                                                                                        color="primary"
                                                                                        class="btn btn_blue"
                                                                                        @click="createReconciliationData(item);miscellanousOperationData = undefined;miscellaneousOperationDialog=true;"
                                                                                    >
                                                                                        OD
                                                                                    </v-btn> -->
                                                                                    </v-card-title>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card>
                                                                    </v-card-text>
                                                                </v-card>
    
                                                                <!-- ** only if generalLedgerTextAux -->
                                                                <!-- // ** GeneralLedger thirdParty -->
                                                                <v-card
                                                                    style="!important; background: #F4F4F4;"
                                                                    elevation="0"
                                                                    v-if="item1.generalLedgerTextAux"
                                                                >
                                                                    <v-card-text
                                                                        @click="
                                                                            addRemoveItemExpanded(
                                                                                item1.expandable,
                                                                                item1.generalLedgerTextAux,
                                                                                'refreshGeneralLedger_aux',
                                                                            )
                                                                        "
                                                                        class="pl-6 d-flex align-center"
                                                                    >
                                                                        <v-icon v-if="item1.expandable">
                                                                            {{
                                                                                isItemExpanded(
                                                                                    item1.generalLedgerTextAux,
                                                                                )
                                                                                    ? "$fa-chevron-up"
                                                                                    : "$fa-chevron-down"
                                                                            }}
                                                                        </v-icon>
    
                                                                        <h3 class="pl-8">
                                                                            {{
                                                                                item1.generalLedgerTextAux
                                                                            }}
                                                                        </h3>
                                                                    </v-card-text>
    
                                                                    <v-card-text
                                                                        v-if="
                                                                            isItemExpanded(
                                                                                item1.generalLedgerTextAux,
                                                                            )
                                                                        "
                                                                        transition="expand"
                                                                        class="px-0 pt-0 pb-2"
                                                                    >
                                                                        <v-card
                                                                            style="
                                                                                background-color: white;
                                                                                border-radius: 25px;
                                                                            "
                                                                        >
                                                                            <v-row
                                                                                no-gutters
                                                                                :key="
                                                                                    refreshGeneralLedger_aux
                                                                                "
                                                                            >
                                                                                <v-col cols="12">
                                                                                    <GeneralLedger
                                                                                        :companyId="
                                                                                            companyId
                                                                                        "
                                                                                        :accountingPeriodId="
                                                                                            item1.periodId
                                                                                        "
                                                                                        :inNm1="false"
                                                                                        :hideOptions="
                                                                                            true
                                                                                        "
                                                                                        :withoutLetteringIfHidedOptions="
                                                                                            true
                                                                                        "
                                                                                        :inThirdParty="
                                                                                            true
                                                                                        "
                                                                                        :thirdPartyType="
                                                                                            item1.thirdPartyType
                                                                                        "
                                                                                        :showThirdParty="
                                                                                            true
                                                                                        "
                                                                                        :refreshCount="
                                                                                            refreshGeneralLedger_aux
                                                                                        "
                                                                                    >
                                                                                    </GeneralLedger>
                                                                                    <!-- :notReconciliated="true" -->
                                                                                    <!-- :inThirdParty="item1.inThirdParty" -->
                                                                                    <!-- :hideMiscellaneousOperationsBtn="true" -->
                                                                                    <!-- :hideThirdPartySwitch="true" -->
                                                                                    <!-- :excludedAccountableAccountFilter="['512000', '589999']" -->
                                                                                </v-col>
                                                                            </v-row>
    
                                                                            <!-- // ** OD -->
                                                                            <v-row no-gutters>
                                                                                <v-col
                                                                                    style="
                                                                                        padding-bottom: 0;
                                                                                    "
                                                                                >
                                                                                    <v-card-title
                                                                                        style="
                                                                                            padding-top: 20px;
                                                                                            padding-bottom: 0;
                                                                                            padding-left: 0;
                                                                                        "
                                                                                    >
                                                                                        <v-spacer />
    
                                                                                        <!-- <v-btn
                                                                                        v-if="(accountingPeriod && accountingPeriod.closed)"
                                                                                        rounded
                                                                                         size="small"
                                                                                        disabled
                                                                                    >
                                                                                        OD
                                                                                    </v-btn> -->
                                                                                        <!-- <v-btn
                                                                                        v-else
                                                                                        rounded
                                                                                         size="small"
    
                                                                                        color="primary"
                                                                                        class="btn btn_blue"
                                                                                        @click="createReconciliationData(item);miscellanousOperationData = undefined;miscellaneousOperationDialog=true;"
                                                                                    >
                                                                                        OD
                                                                                    </v-btn> -->
                                                                                    </v-card-title>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card>
                                                                    </v-card-text>
                                                                </v-card>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </oss-data-table>
                                        </template>
    
                                        <!-- // ++ item0.table (VAT) -->
                                        <template v-if="item0.table">
                                            <!-- <p v-if="item0.table">item0.table : {{item0.table}}</p> -->
                                            <oss-data-table
                                                :headers="gapsResumeTableFilteredHeaders0"
                                                :items="item0.table"
                                                :dense="true"
                                                :hideDefaultHeader="true"
                                                max-height="60vh"
                                            >
                                                <!-- :striped="true" -->
                                                <template #no-data>Aucune anomalie</template>
    
                                                <template v-slot:item="{ item: itemVAT }">
                                                    <tr
                                                        :style="itemVAT.style"
                                                        :class="
                                                            differenceColorClass(itemVAT, itemVAT.month)
                                                        "
                                                        @click="
                                                            addRemoveItemExpanded(
                                                                itemVAT.expandable,
                                                                itemVAT.month,
                                                                undefined,
                                                            )
                                                        "
                                                    >
                                                        <!-- ** isExpanded -->
                                                        <td class="text-center" style="width: 50px">
                                                            <v-icon v-if="itemVAT.expandable">
                                                                {{
                                                                    isItemExpanded(itemVAT.month)
                                                                        ? "$fa-chevron-up"
                                                                        : "$fa-chevron-down"
                                                                }}
                                                            </v-icon>
                                                        </td>
    
                                                        <td class="text-center" style="width: 50px">
                                                            <v-icon
                                                                v-if="itemVAT.documentId"
                                                                color="primary"
                                                                icon="$remove_red_eye"
                                                                @click="
                                                                    openDocument(itemVAT.documentId)
                                                                "
                                                            />
                                                        </td>
    
                                                        <!-- // ** month -->
                                                        <td style="width: 300px">
                                                            <b v-if="itemVAT.month">{{
                                                                itemVAT.month
                                                            }}</b>
                                                            <b v-else />
                                                        </td>
    
                                                        <!-- // ** empty TTCsum -->
                                                        <td class="text-right" style="width: 100px" />
    
                                                        <!-- // ** global amount -->
                                                        <td class="text-right" style="width: 100px">
                                                            <b v-if="itemVAT.HTsum">{{
                                                                newCommonFormatCurrency(
                                                                    itemVAT.HTsum,
                                                                    undefined,
                                                                )
                                                            }}</b>
                                                        </td>
    
                                                        <!-- // ** global VAT amount -->
                                                        <td class="text-right" style="width: 100px">
                                                            <b v-if="itemVAT.VATsum">{{
                                                                newCommonFormatCurrency(
                                                                    itemVAT.VATsum,
                                                                    undefined,
                                                                )
                                                            }}</b>
                                                            <b v-else>-</b>
                                                        </td>
    
                                                        <td
                                                            v-for="(key, index) in columnsToShow"
                                                            :key="index"
                                                            class="text-right"
                                                            style="width: 100px"
                                                        >
                                                            <v-tooltip
                                                                v-if="selectedOptionnalsColumns.length"
                                                                location="bottom"
                                                            >
                                                                <template v-slot:activator="{ props }">
                                                                    <oss-text-field-filled
                                                                        v-bind="props"
                                                                        v-model="itemVAT[key]"
                                                                        outlined
                                                                        dense
                                                                        hide-details
                                                                        style="width: 100px"
                                                                        @update:model-value="
                                                                            modifyManualAmount(
                                                                                acrAmounts,
                                                                                itemVAT,
                                                                                key,
                                                                                'VAT',
                                                                                item0.title,
                                                                                gapsResumeTable,
                                                                            )
                                                                        "
                                                                        @click.stop
                                                                    >
                                                                    </oss-text-field-filled>
                                                                </template>
                                                                <span>Même signe que le total</span>
                                                            </v-tooltip>
    
                                                            <h5 v-else-if="itemVAT[key]">
                                                                {{
                                                                    newCommonFormatCurrency(
                                                                        itemVAT[key],
                                                                        undefined,
                                                                    )
                                                                }}
                                                            </h5>
    
                                                            <h5 v-else>0 &#x20ac;</h5>
                                                        </td>
    
                                                        <!-- // ** empty scrollbar align column -->
                                                        <td style="width: 30px" class="px-0" />
                                                    </tr>
    
                                                    <tr
                                                        v-if="isItemExpanded(itemVAT.month)"
                                                        class="px-0"
                                                    >
                                                        <td colspan="100" class="px-0">
                                                            <template v-if="itemVAT.tables">
                                                                <!-- ** detailled lines -->
                                                                <!-- ** N ['70'] -->
                                                                <!-- ** N-1 ['411', '416', '418', '419', '487'] -->
                                                                <!-- ** N ['411', '416', '418', '419', '487'] -->
                                                                <!-- ** N ['654', '775'] -->
                                                                <oss-data-table
                                                                    :headers="
                                                                        gapsResumeTableFilteredHeaders0
                                                                    "
                                                                    :items="itemVAT.tables"
                                                                    :dense="true"
                                                                    :loading="loading"
                                                                    hideDefaultHeader="true"
                                                                    max-height="60vh"
                                                                >
                                                                    <template
                                                                        v-slot:item="{ item: itemVAT2 }"
                                                                    >
                                                                        <tr
                                                                            :class="
                                                                                differenceColorClass(
                                                                                    itemVAT2,
                                                                                )
                                                                            "
                                                                        >
                                                                            <td
                                                                                class="text-center"
                                                                                style="width: 50px"
                                                                            />
    
                                                                            <td
                                                                                class="text-center"
                                                                                style="width: 50px"
                                                                            />
    
                                                                            <!-- // ** month -->
                                                                            <td style="width: 300px">
                                                                                {{
                                                                                    itemVAT2.title || ""
                                                                                }}
                                                                                -
                                                                                {{
                                                                                    itemVAT2.subtitle ||
                                                                                    ""
                                                                                }}
                                                                            </td>
    
                                                                            <!-- // ** empty TTCsum -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            />
    
                                                                            <!-- // ** global amount -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <b
                                                                                    v-if="
                                                                                        itemVAT2.HTsum
                                                                                    "
                                                                                    >{{
                                                                                        newCommonFormatCurrency(
                                                                                            itemVAT2.HTsum,
                                                                                            undefined,
                                                                                        )
                                                                                    }}</b
                                                                                >
                                                                            </td>
    
                                                                            <!-- // ** global VAT amount -->
                                                                            <td
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <b
                                                                                    v-if="
                                                                                        itemVAT2.VATsum
                                                                                    "
                                                                                    >{{
                                                                                        newCommonFormatCurrency(
                                                                                            itemVAT2.VATsum,
                                                                                            undefined,
                                                                                        )
                                                                                    }}</b
                                                                                >
                                                                                <b v-else>-</b>
                                                                            </td>
    
                                                                            <td
                                                                                v-for="(
                                                                                    key, index
                                                                                ) in columnsToShow"
                                                                                :key="index"
                                                                                class="text-right"
                                                                                style="width: 100px"
                                                                            >
                                                                                <v-tooltip
                                                                                    v-if="
                                                                                        (itemVAT2.HTtextfield &&
                                                                                            key.startsWith(
                                                                                                'HT',
                                                                                            )) ||
                                                                                        (itemVAT2.VATtextfield &&
                                                                                            key.startsWith(
                                                                                                'VAT',
                                                                                            ))
                                                                                    "
                                                                                    location="bottom"
                                                                                >
                                                                                    <template
                                                                                        v-slot:activator="{
                                                                                            props,
                                                                                        }"
                                                                                    >
                                                                                        <oss-text-field-filled
                                                                                            v-bind="
                                                                                                props
                                                                                            "
                                                                                            v-model="
                                                                                                itemVAT2[
                                                                                                    key
                                                                                                ]
                                                                                            "
                                                                                            outlined
                                                                                            dense
                                                                                            hide-details
                                                                                            style="
                                                                                                width: 100px;
                                                                                            "
                                                                                            @update:model-value="
                                                                                                modifyManualAmount(
                                                                                                    acrAmounts,
                                                                                                    itemVAT2,
                                                                                                    key,
                                                                                                    'VAT',
                                                                                                    gapsResumeTable[1]
                                                                                                        .generalLedgerText,
                                                                                                    gapsResumeTable,
                                                                                                    itemVAT.month,
                                                                                                )
                                                                                            "
                                                                                            @click.stop
                                                                                        >
                                                                                        </oss-text-field-filled>
                                                                                    </template>
                                                                                    <span
                                                                                        >Même signe que
                                                                                        le total</span
                                                                                    >
                                                                                </v-tooltip>
    
                                                                                <h5
                                                                                    v-else-if="
                                                                                        itemVAT2[key]
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            itemVAT2[
                                                                                                key
                                                                                            ],
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h5>
    
                                                                                <h5 v-else>
                                                                                    0 &#x20ac;
                                                                                </h5>
                                                                            </td>
                                                                        </tr>
                                                                    </template>
                                                                </oss-data-table>
                                                            </template>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </oss-data-table>
    
                                            <!-- // ** GeneralLedger - VAT -->
                                            <v-card
                                                style="!important; background: #F4F4F4;"
                                                elevation="0"
                                            >
                                                <v-card-text
                                                    @click="
                                                        addRemoveItemExpanded(
                                                            true,
                                                            item0.generalLedgerText,
                                                            'refreshGeneralLedger_vat',
                                                        )
                                                    "
                                                    class="pl-6 d-flex align-center"
                                                >
                                                    <v-icon>
                                                        {{
                                                            isItemExpanded(item0.generalLedgerText)
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"
                                                        }}
                                                    </v-icon>
    
                                                    <h3 class="pl-8">{{ item0.generalLedgerText }}</h3>
                                                </v-card-text>
    
                                                <v-card-text
                                                    v-if="isItemExpanded(item0.generalLedgerText)"
                                                    transition="expand"
                                                    class="px-0 pt-0 pb-2"
                                                >
                                                    <v-card
                                                        style="
                                                            background-color: white;
                                                            border-radius: 25px;
                                                        "
                                                    >
                                                        <v-row no-gutters>
                                                            <v-col cols="12">
                                                                <div
                                                                    v-if="
                                                                        item0.generalLedgerText ===
                                                                            'N - Grand livre - c/445' &&
                                                                        isItemExpanded(
                                                                            item0.generalLedgerText,
                                                                        )
                                                                    "
                                                                    :key="refreshGeneralLedger_vat"
                                                                >
                                                                    <GeneralLedger
                                                                        :companyId="companyId"
                                                                        :accountingPeriodId="
                                                                            accountingPeriodId
                                                                        "
                                                                        :accountableAccountFilter="
                                                                            item0.accountableAccounts
                                                                        "
                                                                        :inNm1="false"
                                                                        :hideOptions="true"
                                                                        :withoutLetteringIfHidedOptions="
                                                                            true
                                                                        "
                                                                        :refreshCount="
                                                                            refreshGeneralLedger_vat
                                                                        "
                                                                    />
                                                                    <!-- :notReconciliated="true" -->
                                                                    <!-- :hideMiscellaneousOperationsBtn="true" -->
                                                                    <!-- :hideThirdPartySwitch="true" -->
                                                                    <!-- :inThirdParty="item0.inThirdParty" -->
                                                                    <!-- @thirdPartyChanged="item0.inThirdParty = !item0.inThirdParty" -->
                                                                    <!-- :excludedAccountableAccountFilter="['512000', '589999']" -->
                                                                </div>
                                                            </v-col>
                                                        </v-row>
    
                                                        <!-- // ** OD -->
                                                        <v-row no-gutters>
                                                            <v-col style="padding-bottom: 0">
                                                                <v-card-title
                                                                    style="
                                                                        padding-top: 20px;
                                                                        padding-bottom: 0;
                                                                        padding-left: 0;
                                                                    "
                                                                >
                                                                    <v-spacer />
    
                                                                    <!-- <v-btn
                                                                        v-if="(accountingPeriod && accountingPeriod.closed)"
                                                                        rounded
                                                                         size="small"
                                                                        disabled
                                                                    >
                                                                        OD
                                                                    </v-btn>
                                                                    <v-btn
                                                                        v-else
                                                                        rounded
                                                                         size="small"
    
                                                                        color="primary"
                                                                        class="btn btn_blue"
                                                                        @click="createReconciliationData(item);miscellanousOperationData = undefined;miscellaneousOperationDialog=true;"
                                                                    >
                                                                        OD
                                                                    </v-btn> -->
                                                                </v-card-title>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-card-text>
                                            </v-card>
                                        </template>
                                    </td>
    
                                    <!-- ** empty scrollbar align column -->
                                    <!-- <td style="width: 17px;">17b</td> -->
                                </tr>
                            </template>
                        </oss-data-table>
    
                        <!-- // ++ if additionalVatAssessmentToDo > -->
                        <!-- // ++ btn OD -->
                        <!-- // ++ Déclaration rectificative à effectuer + btn decl -->
                        <template v-if="additionalVatAssessmentToDo">
                            <div class="mt-4">
                                <!-- // ** OD -->
                                <v-row no-gutters class="py-1" v-if="!disabledOD">
                                    <v-col cols="auto">
                                        <h2 class="d-flex align-center pr-4 yellow_custom--text">
                                            OD de régularisation des écarts < 5&#x20ac;
                                        </h2>
                                    </v-col>
    
                                    <!-- // * oss-help tooltip -->
                                    <v-col cols="1">
                                        <v-tooltip class="d-flex align-center" location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-icon
                                                    color="secondary"
                                                    icon="$oss-help"
                                                    v-bind="props"
                                                />
                                            </template>
    
                                            <h3 class="mb-0 mt-2">Procédure à suivre :</h3>
                                            <br />
                                            <p class="mb-0">
                                                - Il est préférable de corriger les écritures, en
                                                passant par les grands livres contenus dans chaque
                                                section
                                            </p>
                                        </v-tooltip>
                                    </v-col>
    
                                    <v-spacer />
    
                                    <!-- // ** OD -->
                                    <v-col cols="auto" class="d-flex text-right align-center">
                                        <!-- <v-btn
                                            v-if="disabledOD"
                                            dense
                                            rounded
                                            color="primary"
    
                                             size="small"
                                            elevation="0"
                                            class="d-inline px-2"
                                            disabled
                                        >
                                            OD
                                        </v-btn> -->
    
                                        <v-btn
                                            dense
                                            rounded
                                            elevation="0"
                                            class="d-inline px-2"
                                            @click="createRows()"
                                            size="small"
                                        >
                                            OD
                                        </v-btn>
                                        <!-- v-else -->
                                    </v-col>
                                </v-row>
    
                                <!-- // ** Déclaration rectificative -->
                                <v-row no-gutters class="py-1 d-flex align-center">
                                    <v-col cols="auto">
                                        <h2 class="pr-4" color="primary">
                                            Déclaration rectificative à effectuer sur la dernière
                                            période de l'exercice
                                        </h2>
                                    </v-col>
    
                                    <!-- // * oss-help tooltip -->
                                    <v-col cols="1" class="d-flex align-center">
                                        <v-tooltip location="bottom">
                                            <template v-slot:activator="{ props }">
                                                <v-icon
                                                    color="secondary"
                                                    icon="$oss-help"
                                                    v-bind="props"
                                                />
                                            </template>
    
                                            <h3 class="mb-0 mt-2">Procédure à suivre :</h3>
                                            <br />
                                            <p class="mb-0">
                                                - Remplissez les commentaires (la régularisation va
                                                rendre nuls les écarts).
                                            </p>
                                            <p class="mb-0 pl-2">
                                                <b><i>Exemple : </i></b>
                                            </p>
                                            <p class="mb-0 pl-2">
                                                <i>Déclaration rectificative effectuée en 12/2022</i>
                                            </p>
                                            <p class="mb-0 pl-2"><i>20% HT 650 TVA 130</i></p>
                                            <br />
                                            <p class="mb-0">
                                                - Générez une déclaration rectificative sur la dernière
                                                période déclarative (mois ou trimestre) de l'exercice
                                                comptable.
                                            </p>
                                            <br />
                                            <p class="mb-2">
                                                - Révenez sur le contrôle : ceci déclenchera la mise à
                                                jour du tableau ainsi que la validation du contrôle.
                                            </p>
                                        </v-tooltip>
                                    </v-col>
    
                                    <!-- <v-spacer /> -->
    
                                    <!-- <v-col class="d-flex align-center justify-end">
                                        <v-btn rounded @click="globalStep++" size="small">
                                            Déclaration TVA
                                        </v-btn>
                                    </v-col> -->
                                </v-row>
                            </div>
                        </template>
                    </template>
    
                    <!-- // ** connectedDocuments -->
                    <template v-if="!loading && !dataLoading">
                        <AuditConnectedAcrDocuments
                            :connectedDocuments="connectedDocuments"
                            :companyId="companyId"
                            :acKey="key"
                            :auditCheckResult="auditCheckResult || {}"
                            :accountingPeriodId="accountingPeriodId || undefined"
                            @unlinkedDocument="unlinkDocument($event)"
                            @showLinkedDocument="showLinkedDocument($event)"
                        />
                    </template>
    
                    <!-- // ** results -->
                    <template v-if="!loading && !dataLoading">
                        <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                    </template>
    
                    <!-- // ++ longComment  -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <h5 class="pl-4">Commentaires détaillés</h5>
                                </v-card-title>
                            </v-col>
    
                            <!-- <v-spacer></v-spacer> -->
    
                            <!-- // ** expand icon -->
                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6" />
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                showLongComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                            "
                                            @click="showLongComment = !showLongComment"
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
    
                        <v-card-text v-if="showLongComment" no-gutters>
                            <v-row class="pt-6">
                                <v-col style="padding-top: 0">
                                    <v-textarea
                                        v-model="longComment"
                                        auto-grow
                                        class="pt-1"
                                        style="border: 1px #ededed solid"
                                    />
    
                                    <v-row>
                                        <v-spacer />
                                        <v-col cols="auto" class="pt-6">
                                            <v-row class="text-right">
                                                <!-- // ** OD -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"
    
                                                        elevation="0"
                                                        disabled
                                                    >
                                                        OD
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                         size="small"
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="createRows(); miscellaneousOperationDialog=true;"
                                                    >
                                                        OD
                                                    </v-btn>
                                                </v-col> -->
    
                                                <!-- // ** enregistrer -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="
                                                            !accountingPeriod ||
                                                            (accountingPeriod &&
                                                                accountingPeriod.closed)
                                                        "
                                                        rounded
                                                        disabled
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="validateAuditCheckResult()"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>
    
                                                <!-- // ** si false > valider -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"
                                                        elevation="0"
                                                        disabled
                                                    > -->
                                                <!-- {{$t('audit.validate')}} -->
                                                <!-- Valider
                                                    </v-btn>
    
                                                    <v-btn
                                                        v-else-if="!validated"
                                                         size="small"
                                                        rounded
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="validated = !validated; validateAuditCheckResult();"
                                                        > -->
                                                <!-- {{$t('audit.validate')}} -->
                                                <!-- Valider
                                                    </v-btn> -->
    
                                                <!-- // ** si true > invalider -->
                                                <!-- <v-btn
                                                        v-else
                                                         size="small"
                                                        rounded
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="validated = !validated; validateAuditCheckResult();"
                                                        >
                                                        Invalider
                                                    </v-btn>
                                                </v-col> -->
                                            </v-row>
                                        </v-col>

                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
    
                    <!-- // ++ shortComment  -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <h5 class="pl-4">Commentaires synthétiques</h5>
                                </v-card-title>
                            </v-col>
    
                            <!-- <v-spacer></v-spacer> -->
    
                            <!-- // ** expand icon -->
                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6" />
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                showShortComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                            "
                                            @click="showShortComment = !showShortComment"
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
    
                        <v-card-text v-if="showShortComment" no-gutters>
                            <v-row class="pt-6">
                                <v-col style="padding-top: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
    
                                    <!-- // ** Enregistrer valider btns -->
                                    <v-row>
                                        <v-spacer />
    
                                        <v-col cols="auto" class="pt-6">
                                            <v-row class="text-right">
                                                <!-- // ** OD -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"
    
                                                        elevation="0"
                                                        disabled
                                                    >
                                                        OD
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                         size="small"
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="createRows(); miscellaneousOperationDialog=true;"
                                                    >
                                                        OD
                                                    </v-btn>
                                                </v-col> -->
    
                                                <!-- // ** enregistrer -->
                                                <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="
                                                            !accountingPeriod ||
                                                            (accountingPeriod &&
                                                                accountingPeriod.closed)
                                                        "
                                                        rounded
                                                        disabled
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                    <v-btn
                                                        v-else
                                                        rounded
                                                        elevation="0"
                                                        @click="validateAuditCheckResult()"
                                                        size="small"
                                                    >
                                                        Enregistrer
                                                    </v-btn>
                                                </v-col>
    
                                                <!-- // ** si false > valider -->
                                                <!-- <v-col cols="auto" class="text-right">
                                                    <v-btn
                                                        v-if="!accountingPeriod || (accountingPeriod && accountingPeriod.closed)"
                                                        rounded
                                                         size="small"
                                                        elevation="0"
                                                        disabled
                                                    > -->
                                                <!-- {{$t('audit.validate')}} -->
                                                <!-- Valider
                                                    </v-btn>
    
                                                    <v-btn
                                                        v-else-if="!validated"
                                                         size="small"
                                                        rounded
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="validated = !validated; validateAuditCheckResult();"
                                                        > -->
                                                <!-- {{$t('audit.validate')}} -->
                                                <!-- Valider
                                                    </v-btn> -->
    
                                                <!-- // ** si true > invalider -->
                                                <!-- <v-btn
                                                        v-else
                                                         size="small"
                                                        rounded
    
                                                        color="primary"
                                                        elevation="0"
                                                        @click="validated = !validated; validateAuditCheckResult();"
                                                        >
                                                        Invalider
                                                    </v-btn>
                                                </v-col> -->
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </template>

                <!-- // ** OD -->
                <!-- <AccountingItemEdition
                    v-if="miscellaneousOperationDialog"
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="key"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    :accountingItemType="'MISCELLANEOUS_OPERATION'"
                ></AccountingItemEdition> -->

                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="key"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="refresh()"
                        :accountingItemType="'MISCELLANEOUS_OPERATION'"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>

                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->

                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />

                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="key"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </v-window-item>
            <v-window-item :value="1">
                <v-row no-gutters>
                    <v-col cols="12">
                        <DeclarationForm
                            :closureVatMode="true"
                            :closureVatItems="gapsResumeTable[2]"
                            v-if="globalStep === 1"
                            :cerfaNumber="'3310CA3'"
                            :propsStartDate="declarationStartDate"
                            :propsEndDate="declarationEndDate"
                            :closureLastDeclarationData="
                                gapsResumeTable[1].table[gapsResumeTable[1].table.length - 1]
                            "
                            @declarationSent="refresh"
                            @back="globalStep--"
                        >
                        </DeclarationForm>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { cloneDeep, isEmpty, sumBy } from "lodash";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { mathFix } from "../../services/mathServices";

import {
    getAllAcrAmountsCorrections,
    getAllAcrAmountsVAT,
    modifyColumns,
    modifyManualAmount,
    modifySums,
} from "../../../../backend/src/common/audit/auditFunctions";
import { closedPeriod, formatConnectedDocuments } from "../../services/audit/AuditServices";
import AccountableAccountBalanceDetail from "../AccountableAccountBalanceDetail.vue";
import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";

import GeneralLedger from "../GeneralLedger2.vue";
import ossDataTable from "../ossComponents/ossDataTable2.vue";
import DeclarationForm from "../taxForm/declaration/DeclarationForm.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import { CheckBase } from "./CheckBase";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";

import { getDBFormattedDate } from "@/services/dateServices";
import { DialogAction } from "@/services/dialogAction";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";

import { Component, Prop, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccountBalanceDetail,
        AccountingItemEdition2,
        GeneralLedger,
        ossDataTable,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        DeclarationForm,
    },
})
export class CheckClosureVAT2 extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    globalStep = 0;

    loading: boolean = false;
    loading2: boolean = false;
    dataLoading: boolean = true;

    dialogAuditCheckDocumentsManager: boolean = false;

    withAccountingPeriod: boolean = false;
    company: any = {};
    // withAccountingPeriod: boolean = false;

    refreshKey = 0;

    showShortComment: boolean = false;
    showLongComment: boolean = false;

    snackbar1: boolean = false;
    snackbar2: boolean = false;
    expanded471: boolean = false;

    // accountingPeriodEnd: string = ""

    auditCheckResultId: string = "";
    auditCheckResult: any = {};

    noResults: boolean = false;
    validated: boolean = false;
    reviewed: number = 0;

    longComment: string = "";
    shortComment: string = "";

    // newResultDocumentIds: Array<any> = [];

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: Array<any> = [];
    previousPeriodDocuments: any = {};
    nextPeriodDocuments: any = {};

    annualGap: Array<any> = [];
    // makeAnnualGapSum: boolean = false
    comments: string = "";

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    manualJustificationExpand: Array<any> = [];
    bankAccount512000Expand: Array<any> = [];
    bankAccount512999Expand: Array<any> = [];
    commentExpand: Array<any> = [];
    shortCommentExpand: Array<any> = [];

    accountableAccountFilter416 = ["416"];
    accountableAccountFilterAdjustments = ["418", "419"]; // no 487 : no impact on VAT declaration
    accountableAccountFilter4457 = ["4457"];
    accountableAccountFilter44587 = ["44587"];
    accountableAccountFilter70 = ["70"];
    accountableAccountFilter654 = ["654"];
    accountableAccountFilter775 = ["775"];

    refreshGeneralLedger471: number = 0;
    refreshGeneralLedger_general: number = 50;
    refreshGeneralLedger_aux: number = 100;
    refreshGeneralLedger_vat: number = 150;

    formIsValid: boolean = false;

    deleteBankReconciliationDialog: boolean = false;
    deleteAllSelectionnedBankReconciliationDialog: boolean = false;
    toDeleteBankReconciliationItem: any;
    toDeleteBankReconciliationIndex: any;
    selectedBankReconciliationCheckBox = [];

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    selectedOptionnalsColumns: Array<any> = [];

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    get declarationStartDate() {
        return moment(this.accountingPeriod.end).startOf("month").format();
    }

    get declarationEndDate() {
        return moment(this.accountingPeriod.end).endOf("month").format();
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    get isAccountingUser() {
        return this.$store.state.user.isAccountingUser;
    }

    get previousAccountingPeriod() {
        if (
            this.accountingPeriods &&
            this.accountingPeriods.length &&
            this.accountingPeriods.length > 1 &&
            this.accountingPeriod
        ) {
            const endPrevious = moment(this.accountingPeriod.start)
                .add(-1, "days")
                .format("YYYY-MM-DD");
            const previousAP = this.accountingPeriods.find((ap) => ap.end.startsWith(endPrevious));
            if (previousAP) {
                return previousAP;
            }
        }
        return {};
    }

    // ** AccountableAccountBalanceDetail
    accountableAccountInfo(bankAccountName, accountableAccountName) {
        return {
            name: accountableAccountName,
            bankAccountType: "BANK",
            bankAccountName: bankAccountName,
        };
    }

    newManualBalanceDialog: boolean = false;

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    isNotSubjectToVAT(value: string) {
        return isNotSubjectToVAT(value);
    }

    // ///////// CUSTOMERS SETTINGS /////////////////
    key: string = "t2BmOXVwxUoRNRZfKGFU4JEX";

    // ////////////////////////////////////////////////

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    modifyManualAmount(
        acrAmounts,
        item,
        key,
        type,
        generalLedgerText,
        gapsResumeTable: Array<any> = [],
        item1Title: string = "",
    ) {
        modifyManualAmount(
            acrAmounts,
            item,
            key,
            type,
            generalLedgerText,
            gapsResumeTable,
            item1Title,
        );
    }

    // defaultAnnualGap: Array<any> = [
    //     {
    //         content: "Chiffre d'affaires",
    //         HTsum: 0,
    //         VATsum: 0,
    //         HT20: 0,
    //         VAT20: 0,
    //         HT10: 0,
    //         VAT10: 0,
    //         HT08: 0,
    //         VAT08: 0,
    //         HT05: 0,
    //         VAT05: 0,
    //         HT02: 0,
    //         VAT02: 0,
    //         HT00: 0,
    //         HT30: 0,
    //         HT80: 0,
    //         HT90: 0,
    //         HT50: 0
    //     },
    //     {
    //         content: "TVA collectée déclarée",
    //         HTsum: 0,
    //         VATsum: 0,
    //         HT20: 0,
    //         VAT20: 0,
    //         HT10: 0,
    //         VAT10: 0,
    //         HT08: 0,
    //         VAT08: 0,
    //         HT05: 0,
    //         VAT05: 0,
    //         HT02: 0,
    //         VAT02: 0,
    //         HT00: 0,
    //         HT30: 0,
    //         HT80: 0,
    //         HT90: 0,
    //         HT50: 0
    //     }
    // ]

    // ++++++++++++ CHECK HEADERS - MISSING SALES-INVOICES +++++++++
    // salesNHeaders: Array<any> = [
    //     {
    //         text: "Compte",
    //         value: "name",
    //         align: "left",
    //         sortable: true
    //     },
    //     {
    //         text: "Total HT",
    //         value: "HTsum",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "Total TVA",
    //         value: "VATsum",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT 20%",
    //         value: "HT20",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "TVA 20%",
    //         value: "VAT20",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT 10%",
    //         value: "HT10",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "TVA 10%",
    //         value: "VAT10",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT 8,5%",
    //         value: "HT08",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "TVA 8,5%",
    //         value: "VAT08",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT 5,5%",
    //         value: "HT05",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "TVA 5,5%",
    //         value: "VAT05",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT 2,1%",
    //         value: "HT02",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "TVA 2,1%",
    //         value: "VAT02",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT exonéré",
    //         value: "HT00",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT Intracom",
    //         value: "HT30",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT Export",
    //         value: "HT80",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT autoliquidation",
    //         value: "HT90",
    //         align: "right",
    //         sortable: true
    //     },
    //     {
    //         text: "HT (% TVA pas connu)",
    //         value: "HT50",
    //         align: "right",
    //         sortable: true
    //     },
    // ];

    persistentGapsResumeTableHeaders: Array<any> = [
        {
            text: "",
            value: "",
            width: "50px",
            align: "left",
        },
        {
            text: "",
            value: "",
            width: "300px",
            align: "left",
        },
        {
            text: "Total TTC",
            value: "TTCsum",
            width: "100px",
            align: "right",
            class: "grey--text",
            style: "font-weight: bold; border-end:1px solid #dddddd;",
        },
        {
            text: "Total HT",
            value: "HTsum",
            width: "100px",
            align: "right",
        },
        {
            text: "Total TVA",
            value: "VATsum",
            width: "100px",
            align: "right",
        },
    ];

    optionnalsGapsResumeTableHeaders: any = [
        {
            text: "HT 20%",
            value: "HT20",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "TVA 20%",
            value: "VAT20",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT 10%",
            value: "HT10",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "TVA 10%",
            value: "VAT10",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT 8,5%",
            value: "HT08",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "TVA 8,5%",
            value: "VAT08",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT 5,5%",
            value: "HT05",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "TVA 5,5%",
            value: "VAT05",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT 2,1%",
            value: "HT02",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "TVA 2,1%",
            value: "VAT02",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT exonéré",
            value: "HT00",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT Intracom",
            value: "HT30",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT Export",
            value: "HT80",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT autoliquidation",
            value: "HT90",
            width: "100px",
            align: "right",
            sortable: false,
        },
        {
            text: "HT (% TVA pas connu)",
            value: "HT50",
            width: "100px",
            align: "right",
            sortable: false,
        },
    ];

    gapsResumeTableFilteredHeaders: Array<any> = this.persistentGapsResumeTableHeaders;

    @Watch("selectedOptionnalsColumns")
    changedSelectedOptionnalColumns() {
        const modifiedColumns = modifyColumns(
            this.acrAmounts,
            this.gapsResumeTable,
            this.persistentGapsResumeTableHeaders,
            this.columnsToShowFromDocuments,
            this.columnsToShow,
            this.optionnalsGapsResumeTableHeaders,
            this.selectedOptionnalsColumns,
            this.gapsResumeTableFilteredHeaders,
        );

        if (modifiedColumns) {
            this.gapsResumeTable = modifiedColumns.gapsResumeTable || [];
            this.gapsResumeTableFilteredHeaders =
                modifiedColumns.gapsResumeTableFilteredHeaders || [];
            this.gapsResumeTableFilteredHeaders0 = cloneDeep(this.gapsResumeTableFilteredHeaders);
            this.gapsResumeTableFilteredHeaders.push({
                text: "",
                value: "",
                // width: "34px"
            });
            this.columnsToShow = modifiedColumns.columnsToShow || [];
        }
    }

    // ++++++++++++++++++ ACCOUNTING LINES and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.key,
                accountingPeriodId: this.accountingPeriodId || undefined,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data?.auditItems?.items?.[0]) {
                    this.auditItems = cloneDeep(data.auditItems.items[0]);

                    if (!isEmpty(this.auditItems)) {
                        // this.initialiseCompany()
                        if (this.auditItems.company) {
                            this.company = this.auditItems.company;
                        }

                        this.gapsResumeTable = this.auditItems.gapsResumeTable || [];

                        this.show471GL = this.auditItems.show471GL || false;
                        if (this.show471GL) {
                            this.addRemoveItemExpanded(
                                true,
                                "expand471",
                                "refreshGeneralLedger471",
                            );
                        }

                        this.columnsToShowFromDocuments =
                            this.auditItems.columnsToShowFromDocuments || [];
                        this.columnsToShow = this.auditItems.columnsToShowFromDocuments || [];

                        if (this.columnsToShowFromDocuments.length) {
                            this.selectGapsResumeTableHeaders =
                                this.optionnalsGapsResumeTableHeaders.filter(
                                    (h) => !this.columnsToShowFromDocuments?.includes(h.value),
                                );
                        } else {
                            this.selectGapsResumeTableHeaders =
                                this.optionnalsGapsResumeTableHeaders;
                        }

                        if (this.auditItems.auditCheckResult) {
                            this.auditCheckResult = this.auditItems.auditCheckResult;
                            if (this.auditCheckResult.documents) {
                                this.connectedDocuments = this.auditCheckResult.documents;
                            }

                            if (this.auditCheckResult.results) {
                                this.results = this.auditCheckResult.results;
                            }

                            if (this.auditCheckResult.reviewed) {
                                this.reviewed = this.auditCheckResult.reviewed;
                            }

                            if (this.auditCheckResult.data) {
                                this.acrData = this.auditCheckResult.data;

                                if (
                                    this.acrData.acrAmounts &&
                                    (this.acrData.acrAmounts.corrections?.length ||
                                        this.acrData.acrAmounts.VAT?.length)
                                ) {
                                    this.acrAmounts = cloneDeep(this.acrData.acrAmounts) || {};

                                    if (this.acrAmounts.corrections?.length) {
                                        this.gapsResumeTable[0].tables =
                                            getAllAcrAmountsCorrections(
                                                this.gapsResumeTable[0].tables,
                                                this.acrAmounts.corrections,
                                            );
                                    }

                                    if (this.acrAmounts.VAT?.length) {
                                        this.gapsResumeTable[1].table = getAllAcrAmountsVAT(
                                            this.gapsResumeTable[1].table,
                                            this.acrAmounts.VAT,
                                        );
                                    }

                                    this.gapsResumeTable = modifySums(this.gapsResumeTable);
                                }

                                const allColumns = modifyColumns(
                                    this.acrAmounts,
                                    this.gapsResumeTable,
                                    this.persistentGapsResumeTableHeaders,
                                    this.columnsToShowFromDocuments,
                                    this.columnsToShow,
                                    this.optionnalsGapsResumeTableHeaders,
                                    this.selectedOptionnalsColumns,
                                    this.gapsResumeTableFilteredHeaders,
                                );

                                if (allColumns) {
                                    this.gapsResumeTable = allColumns.gapsResumeTable || [];
                                    this.gapsResumeTableFilteredHeaders =
                                        allColumns.gapsResumeTableFilteredHeaders || [];
                                    this.gapsResumeTableFilteredHeaders0 = cloneDeep(
                                        this.gapsResumeTableFilteredHeaders,
                                    );
                                    this.gapsResumeTableFilteredHeaders0.push({
                                        text: "",
                                        value: "",
                                    });
                                }

                                this.longComment = cloneDeep(this.acrData.longComment) || "";
                                this.shortComment = cloneDeep(this.acrData.shortComment) || "";

                                // ** if validated = true and gaps > validated = false
                                // ** if validated = false and no more gaps > validated = true
                                this.validated = this.acrData.validated || false;
                                this.reviewed = this.acrData.reviewed || 0;

                                // /////////////////////////////////////////////////////////////////////////////
                                // // to be decommented when the automatic 
                                // // "Déclaration rectificative à effectuer sur la dernière période de l'exercice" btn 
                                // // will be available again //////////////////////////////////////////////////
                                // if (this.additionalVatAssessmentToDo && (this.validated || this.reviewed)) {
                                //     this.validated = false;
                                //     this.reviewed = 0;
                                //     this.validateAuditCheckResult();
                                // }                                                           
                            }

                            if (this.auditCheckResult.results?.length) {
                                this.previousDocumentsIds = this.auditCheckResult.results.map(
                                    (rd) => rd.id,
                                );
                            }
                        } else {
                            const allColumns = modifyColumns(
                                this.acrAmounts,
                                this.gapsResumeTable,
                                this.persistentGapsResumeTableHeaders,
                                this.columnsToShowFromDocuments,
                                this.columnsToShow,
                                this.optionnalsGapsResumeTableHeaders,
                                this.selectedOptionnalsColumns,
                                this.gapsResumeTableFilteredHeaders,
                            );
                            if (allColumns) {
                                this.gapsResumeTable = allColumns.gapsResumeTable || [];
                                this.gapsResumeTableFilteredHeaders =
                                    allColumns.gapsResumeTableFilteredHeaders || [];
                                this.gapsResumeTableFilteredHeaders0 = cloneDeep(
                                    this.gapsResumeTableFilteredHeaders,
                                );
                                this.gapsResumeTableFilteredHeaders0.push({
                                    text: "",
                                    value: "",
                                });
                            }
                        }

                        this.defaultRatesTable = this.auditItems.defaultRatesTable;

                        this.allOptionnalColumns = this.auditItems.allOptionnalColumns;

                        if (this.auditItems.auditCheck?.key) {
                            this.auditCheckKey = this.auditItems.auditCheck.key;
                        } else {
                            this.auditCheckKey = "";
                        }
                    }
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: Array<any> = [];

    show471GL: Boolean = false;

    gapsResumeTable: Array<any> = [];

    auditCheckKey: string = "";

    acrData: any = {};

    acrAmounts: any = {};

    previousDocumentsIds: Array<any> = [];

    itemExpanded = [];

    columnsToShowFromDocuments = [];

    columnsToShow = [];

    gapsResumeTableFilteredHeaders0: Array<any> = [];

    defaultRatesTable = {};

    // selectGapsResumeTableHeaders = []

    columnsHT = [];

    columnsVAT = [];

    isItemExpanded(item) {
        if (!item) {
            return;
        }

        const index = this.itemExpanded.indexOf(item);
        if (index === -1) {
            return false;
        }
        return true;
    }

    addRemoveItemExpanded(expandable, itemTitle, refreshGlKey) {
        if (!expandable) {
            return;
        }

        if (refreshGlKey) {
            this[refreshGlKey]++;
        }

        const index = this.itemExpanded.indexOf(itemTitle);
        if (index === -1) {
            this.itemExpanded.push(itemTitle);
        } else {
            this.itemExpanded.splice(index, 1);
        }
    }

    isManualJustificationExpanded(item) {
        if (!item) {
            return;
        }

        const index = this.manualJustificationExpand.indexOf(item.id);
        return index !== -1;
    }

    addRemoveBankAccountManualJustification(item) {
        if (!item) {
            return;
        }

        const index = this.manualJustificationExpand.indexOf(item.id);
        if (index === -1) {
            this.manualJustificationExpand.push(item.id);
        } else {
            this.manualJustificationExpand.splice(index, 1);
        }
    }

    openBankReconciliationDialog(item, index: number) {
        this.toDeleteBankReconciliationItem = item;
        this.toDeleteBankReconciliationIndex = index;
    }

    selectAll(item, index) {
        const balances = item.balances;
        const bankAccountIndex = index;
        if (this.selectedBankReconciliationCheckBox.length === 0) {
            for (const i in balances) {
                // bankAccountIndex-balanceIndex
                this.selectedBankReconciliationCheckBox.push(`${bankAccountIndex}-${i}`);
            }
        } else {
            this.selectedBankReconciliationCheckBox = [];
        }
        this.refreshKey++;
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger;
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    difference(balance1, balance2) {
        if (balance1 === undefined) return "-";
        if (balance2 === undefined) return "-";
        const diff = balance1 - balance2;
        return diff;
    }

    getDuplicated(item, bal) {
        return item.balances.filter(
            (ba) => moment(ba.date).isSame(moment(bal.date)) && ba.id !== bal.id,
        );
    }

    differenceColorClass(item, title: string = undefined) {
        // ** declarations don't have TTC
        if (!title || title === "+ Chiffre d'affaires calculé" || title === "ECARTS") {
            const TTCsum = mathFix(item.TTCsum || 0, 2);
            const calculatedTTC = mathFix(item.HTsum + item.VATsum, 2) || 0;

            let othersSum = 0;
            for (const key in item) {
                if (/^(HT|VAT)\d+$/.test(key)) {
                    // Check if key is starting with HT or VAT + digits
                    othersSum += item[key];
                }
            }

            if (TTCsum != calculatedTTC || TTCsum != mathFix(othersSum, 2)) {
                return "text-red";
            }
        }

        if (item.month?.length && item.als4458x?.length) {
            return "text-red";
        }
        if (title === "- TVA collectée déclarée" && item.errors?.declarationsWith4458x?.length) {
            return "text-red";
        }
        return;
    }

    deltaPreviousMonth(balances, i) {
        if (i === 0) {
            return "-";
        }
        const difference = balances[i].selected.balance - balances[i].glBalance;
        if (!difference) {
            return "-";
        }
        const pmDifference = balances[i - 1].selected.balance - balances[i - 1].glBalance;
        return this.difference(difference, pmDifference);
    }

    computeBalancesLoading = false;

    setBalance(balance, balanceIndex, bab) {
        balance[balanceIndex] = bab;
        this.refreshKey++;
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        if (acrId) {
            await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                variables: { id: acrId },
            });

            // await this.createUserActivity("DELETE") // deprecated

            this.refresh();
        }
    }

    async validateAuditCheckResult(action = undefined) {
        const acrData: any = this.acrData || {};
        acrData.acrAmounts = this.acrAmounts || {};
        acrData.longComment = this.longComment || "";
        acrData.shortComment = this.shortComment || "";
        acrData.validated = this.validated || false;
        acrData.reviewed = this.reviewed || 0;

        if (
            this.key &&
            this.companyId &&
            this.accountingPeriodId &&
            this.auditCheckResult &&
            this.acrData
        ) {
            const auditCheckResultVariables: any = {
                id: this.auditCheckResult?.id || "",
                key: this.key + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: acrData.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                // thirdPartyCompanyUpdate: al.object && al.object.thirdPartyCompany && al.object.thirdPartyCompany.id ? { connect: { id:al.object.thirdPartyCompany.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                // bankAccountCreateConnection: { connect: { id: item.id } },
                // bankAccountUpdateConnection: { connect: { id: item.id } },
                // documentCreateConnection:
                // documentUpdateConnection:
                // accountingLineCreateConnection: {connect: {id: currentAlAcrData.alId}},
                // accountingLineUpdateConnection: {connect: {id: currentAlAcrData.alId}},
                // deleteDocuments: this.auditItems?.previousDocumentsIds || [], // ** previous results, if to delete
                // documents: [],  // ** results = générés par le contrôle
                connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
                data: acrData,
                auditCheckKey: this.key,
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };

            if (auditCheckResultVariables) {
                const upsertDone = await this.$apollo.mutate({
                    mutation: UPSERT_AUDIT_CHECK_RESULT,
                    variables: auditCheckResultVariables,
                });
                if (upsertDone?.data?.upsertAuditCheckResult?.id) {
                    // ++++++++++++++ RESET +++++++++++++++++++
                    this.refresh();
                }
            }

            // await this.createUserActivity(action) // deprecated

            // this.newResultDocumentIds = [];
        }

        //  this.refreshGeneralLedger is done in addRemoveItemExpanded()
    }

    // initialiseCompany() {
    // this.accountableAccounts = []
    // }

    defaultRow: any = {
        date: "",
        wording: "",
        reason: "",
        debit: 0,
        credit: 0,
    };

    columnToShow(key) {
        return this.columnsToShow.includes(key);
    }

    openDocument(documentId) {
        this.$router.push({
            name: "document",
            params: {
                companyId: this.companyId,
                id: documentId,
            },
        });
    }

    get additionalVatAssessmentToDo() {
        if (this.gapsResumeTable?.[2]?.title) {
            const keys = Object.keys(this.gapsResumeTable[2]);

            for (const key of keys) {
                const gap = this.gapsResumeTable?.[2][key];

                if (
                    typeof gap === "number" &&
                    ((key.startsWith("HT") && (gap > 10 || gap < -10)) ||
                        (key.startsWith("VAT") && (gap > 1 || gap < -1)))
                ) {
                    // /////////////////////////////////////////////////////////////////////////////
                    // // to be decommented when the automatic 
                    // // "Déclaration rectificative à effectuer sur la dernière période de l'exercice" btn 
                    // // will be available again //////////////////////////////////////////////////
                    // this.validated = false;
                    // this.reviewed = 0;
                    return true;
                }
            }
        }
        return false;
    }

    // checkSums(item) {
    //     let calculatedHTsum = 0
    //     let calculatedVATsum = 0

    //     if (this.columnsHT.length) {
    //         for (const HTkey of this.columnsHT) {
    //             calculatedHTsum += item[HTkey]
    //         }

    //     }
    //     if (this.columnsVAT.length) {
    //         for (const VATkey of this.columnsVAT) {
    //             calculatedVATsum += item[VATkey]
    //         }
    //     }

    //     if ((item.HTsum === calculatedHTsum) && (item.VATsum === calculatedVATsum)) {
    //         return false
    //     }
    //     return true
    // }

    createRows() {
        this.miscellanousOperationData = [];
        const row = {
            date: getDBFormattedDate(this.accountingPeriod.end) || getDBFormattedDate(moment()),
            accountableAccount: { name: "" },
            wording: "Regul de clôture de TVA " + moment(this.accountingPeriod.end).format("YYYY"),
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(row)));
        this.miscellaneousOperationDialog = true;
    }

    onAccountingItemEditionUpsert(result) {
        this.miscellaneousOperationDialog = false;

        // this.newResultDocumentIds =
        //     !result.errors?.length && result.output?.documents?.length
        //         ? result.output.documents.map((d) => ({ id: d.outputId }))
        //         : [];

        this.validateAuditCheckResult();
    }

    get disabledOD() {
        if (this.accountingPeriod?.closed) {
            return true;
        }
        if (!this.gapsResumeTable?.[2]?.VATsum) {
            return true;
        }
        if (this.gapsResumeTable[2].VATsum <= 5 || this.gapsResumeTable[2].VATsum >= 5) {
            return true;
        }
        return false;
    }

    get hideControl() {
        if (this.company?.id) {
            if (
                !this.company.incomeCategory ||
                !this.company.taxRegime ||
                !this.company.vatOption ||
                !this.company.vatSystem
            ) {
                return true;
            }
        }
        return false;
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
        return false;
    }

    get pStyle() {
        return "font-size: 13px; font-weight: 500; color: grey; align: center; ";
    }
}

export default toNative(CheckClosureVAT2);
</script>
